export default __webpack_public_path__ + "static/modal-capsule-e92cb1fba71821a645467f37e2f775bd.png";